// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
/* eslint-disable-next-line no-unused-vars */
import React from 'react';
import { get } from 'lodash';

import { isolateComponent } from '@zapier/common-utils';
import {
  AccountsMenuLinks,
  moveZapsLink,
} from '@zapier/design-system-patterns/src/components/UniversalNav/constants';

import useAccountsMenuData from './utils/useAccountsMenuData';
import AccountsMenu, { type Props as AccountsMenuProps } from './AccountsMenu';

/** @jsx isolateComponent */

type Props = {
  ...$Diff<
    AccountsMenuProps,
    {
      // Provided by `AccountsMenuContainer`.
      accounts: $PropertyType<AccountsMenuProps, 'accounts'>,
      email: $PropertyType<AccountsMenuProps, 'email'>,
      // Handled by `AccountsMenu`'s `defaultProps`.
      menuLabel: $PropertyType<AccountsMenuProps, 'menuLabel'>,
      menuLinks: $PropertyType<AccountsMenuProps, 'menuLinks'>,
    }
  >,
};

/**
 * Renders `AccountsMenu` with accounts data
 */
const AccountsMenuContainer = (props: Props) => {
  const result = useAccountsMenuData();
  const { data } = result;

  // The display name for an account is account owner's name
  const accounts = get(data, ['accounts'], []).map(account => ({
    id: account.id,
    name: account.normalizedName,
    imageUrl: account.normalizedImageUrl,
  }));

  const menuLinks = [
    accounts.length > 1 ? moveZapsLink : undefined,
    ...AccountsMenuLinks,
  ].filter(Boolean);

  const email = get(data, ['currentUserV2', 'email'], '');

  return (
    <AccountsMenu
      accounts={accounts}
      email={email}
      menuLinks={menuLinks}
      {...props}
    />
  );
};

export default AccountsMenuContainer;
